<template>
  <div>
    <div class="customer-left-menu d-none d-md-block">
      <h2>
        <a :to="{ name: '/' }" class="btn btn-primary btn-block text-white">Continue Shopping</a>
      </h2>
      <ul>
        <li>
          <router-link :to="{ name: 'profile' }">Your Profile</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Wishlist' }">Wishlist</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'order' }">Your Orders</router-link>
        </li>
        <li> 
          <router-link :to="{ name: 'Addresses' }">Shipping Addresses</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Change-Password' }">Change Password</router-link>
        </li>
        <li>
          <a href="javascript:;" @click="logout">Logout </a>
        </li>
      </ul>
    </div>
    <div class="mobile-account-menu d-block d-md-none">
      <ul>
        <li>
          <router-link :to="{ name: 'profile' }">Profile</router-link>
        </li>
        <li>
          <router-link :to="{ name: '' }">Wishlist</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'order' }">Orders</router-link>
        </li>
        <li>
          <router-link :to="{ name: '' }">Addresses</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Change-Password' }">Password</router-link>
        </li>
        <li>
          <a href="javascript:;" @click="logout">Logout</a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      mrPoint: 0,
    };
  },
  methods: {
    logout() {
      this.$helper.logout();
    },
    getMRPoint() {
      this.$authHttp
        .get("customer-point")
        .then(response => {
          this.mrPoint = response.data.point;
          console.log(this.mrPoint)
        })
        .catch(e => {
          console.log(e);
        });
    },
  },
  mounted() {
    this.getMRPoint();
  }
};
</script>
